import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { userDetails } from "../../api/User";

export const fetchMe = createAsyncThunk("auth/fetchMe", async (_, thunkAPI) => {
  try {
    const data = await userDetails();

    if (!data || data.success === false) {
      throw new Error("Not authenticated");
    }

    return data.user;
  } catch (err) {
    return thunkAPI.rejectWithValue(null);
  }
});

const initialState = {
  isAuth: false,
  userInfo: null,
  loading: true,
};

const authSlice = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    logout(state) {
      state.isAuth = false;
      state.userInfo = null;
      state.loading = false;
    },
    setUserInfo(state, action) {
      state.userInfo = action.payload;
      state.isAuth = !!action.payload;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMe.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMe.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuth = true;
        state.userInfo = action.payload;
      })
      .addCase(fetchMe.rejected, (state) => {
        state.loading = false;
        state.isAuth = false;
        state.userInfo = null;
      });
  },
});

export const { logout, setUserInfo } = authSlice.actions;
export default authSlice.reducer;